var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testReport"},[_c('Home'),_c('Pages2'),_c('Pages4'),_c('Pages6'),_c('Pages7'),_c('Pages9'),_c('Pages3'),_c('Pages17'),_c('Pages18'),_c('Pages19'),_c('Pages11'),_c('Pages12'),_c('Pages13'),_c('Pages20'),_c('Pages15')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }